// Banner
import AltadisBanner from '../../assets/images/our-companies-details/topbanner-our-comp-altadis.png';
import AltadisBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - Altadis - mobile.png';
import MCbanner from '../../assets/images/our-companies-details/topbanner-our-comp-montecristo.png';
import MCBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - Montecristo - mobile.png';
import RYJbanner from '../../assets/images/our-companies-details/topbanner-our-comp-romeo.png';
import RYJBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - Romeo - mobile.png';
import CTAbanner from '../../assets/images/our-companies-details/topbanner-our-comp-CTA.png';
import CTABannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - CTA - mobile.png';
import MSCbanner from '../../assets/images/our-companies-details/topbanner-our-comp-MSC.png';
import MSCBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - MSC - mobile.png';
import JRcigarsBanner from '../../assets/images/our-companies-details/topbanner-our-comp-JRCigars.png';
import JRcigarsBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - JRCigars - mobile.png';
import CigarsComBanner from '../../assets/images/our-companies-details/topbanner-our-comp-cigars.png';
import CigarsComBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - Cigars.com - mobile.png';
import SeriousCigarsBanner from '../../assets/images/our-companies-details/topbanner-our-comp-serious.png';
import SeriousCigarsBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - SeriousCigars - mobile.png';
import BTDbanner from '../../assets/images/our-companies-details/topbanner-our-comp-BTD.png';
import BTDBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - BTD - mobile.png';
import SantaClaraBanner from '../../assets/images/our-companies-details/topbanner-our-comp-SantaClara.png';
import SantaClaraBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - SantaClara - mobile.png';
import CDMbanner from '../../assets/images/our-companies-details/topbanner-our-comp-CDM.png';
import CDMBannerMobile from '../../assets/images/our-companies-details/Our Company - Top Banner - CDM - mobile.png';

// Logos
import AltadisLogo from '../../assets/images/logos/altadis.png';
import SantaClaraLogo from '../../assets/images/logos/santa-clara.png';
import MSClogo from '../../assets/images/logos/msc.png';
import BTDlogo from '../../assets/images/logos/btd-red.png';
import CDMlogo from '../../assets/images/logos/cdm.png';
import RYJlogo from '../../assets/images/logos/ryj.png';
import JRlogo from '../../assets/images/logos/jr-cigars.png';
import MClogo from '../../assets/images/logos/mc.png';
import CigarsLogo from '../../assets/images/logos/cigars-com-dark.png';
import SeriousCigarsLogo from '../../assets/images/logos/serious-cigars.png';
import CTAlogo from '../../assets/images/logos/cta.png';

const companies = {
  "altadis-usa" : {
    name: "Altadis U.S.A.",
    tagline: "Makers of some of the world's most renowned premium cigar brands",
    content: `<p>If you have ever enjoyed a premium cigar, there's a good chance you've enjoyed a cigar crafted by Altadis U.S.A. Altadis U.S.A. is responsible for some of the world's most renowned consumer facing brands that have shaped the industry’s premium cigar standards.</p><p>Altadis U.S.A. operates production facilities in the Dominican Republic and Honduras and partners with factories in Mexico and Nicaragua. Altadis and its affiliates employ over 5,000 employees worldwide and strive to provide them with an outstanding working environment.</p><p>Altadis U.S.A. products are known for their craftsmanship, value and quality. Let our profile speak for itself: Montecristo, Romeo y Julieta, H.Upmann, Henry Clay and Trinidad. To view the full product portfolio please visit <a href="https://www.altadisusa.com">altadisusa.com</a>.</p>`,
    links: {
      web: "https://www.altadisusa.com/",
    },
    logo_image: AltadisLogo,
    banner_image: AltadisBanner,
    banner_image_mobile: AltadisBannerMobile,
  },

  "montecristo" : {
    name: "Montecristo",
    tagline: "Setting the premium cigar standard",
    content: `<p>Since 1935, the roots of Montecristo Cigars have been growing and exceeding expectations for what a premium cigar should be. As one of the most well-known premium cigars, Montecristo is the pinnacle of premium cigars.</p><p>The Montecristo cigar collection continues to grow with the latest releases like Montecristo Epic Craft Cured and Montecristo Nicaragua. To view the full portfolio please visit montecristo.com.</p>`,
    links: {
      web: "https://montecristo.com/",
    },
    logo_image: MClogo,
    banner_image: MCbanner,
    banner_image_mobile: MCBannerMobile,
  },

  "romeo-y-julieta" : {
    name: "Romeo y Julieta",
    tagline: "Experience the legendary cigars",
    content: `<p>First established in 1875 in Cuba, Romeo y Julieta continues to up the standard in the cigar industry with each product release. Romeo y Julieta cigars have enjoyed over 140 years of recognition and continue to be coveted by adult cigar aficionados.</p><p>Romeo y Julieta continues to expand their already diverse product portfolio - with the latest releases like Romeo y Julieta San Andrés and Romeo y Julieta 1875 Nicaragua. To view all of the Romeo y Julieta products, please visit romeoyjulietacigars.com.</p>`,
    links: {
      web: "https://romeoyjulietacigars.com/",
    },
    logo_image: RYJlogo,
    banner_image: RYJbanner,
    banner_image_mobile: RYJBannerMobile,
  },

  "chase-the-ace" : {
    name: "Chase The Ace",
    tagline: "Test your skills to win Romeo y Julieta prizes",
    content: `<p>Romeo y Julieta is a brand with classic roots that continues to grow and modernize with time. As a tribute to its modern customers, Altadis U.S.A. is refreshing the way that the cigar community interacts with the brand.</p><p>Chase the Ace, launched in August 2018, is the exciting new way to win coupon prizes on Romeo y Julieta cigars. Through an interactive golf game, trivia and sharing your favorite Romeo Moment, users can play to win. On the business side, the platform drives adult consumers in-store through coupons to be used at retail locations across the United States.</p><p>Chase the Ace is the first of its kind - an innovation in the cigar industry bringing recognition to a national brand and driving adult consumers in-store. Check out the game online or in the play store.</p>`,
    links: {
      web: "https://www.romeochasetheace.com/",
    },
    buttons: {
      android: ''
    },
    logo_image: CTAlogo,
    banner_image: CTAbanner,
    banner_image_mobile: CTABannerMobile,
  },

  "montecristo-social-club" : {
    name: "Montecristo Social Club",
    tagline: "Join the Community",
    content: `<p>Montecristo Social Club combines the best aspects of the cigar community - the latest news and products, the hottest events and cigar education.</p><p>MSC is dedicated to bringing the premier cigar experience to its members through an online community. Never before has it been so simple to keep up with all things premium cigar. Montecristo Social Club is the place for aspiring fans and aficionados alike.</p><p>Check it out at <a href="https://www.montecristosocialclub.com">montecristosocialclub.com</a>!</p>`,
    links: {
      web: "https://www.montecristosocialclub.com/",
    },
    logo_image: MSClogo,
    banner_image: MSCbanner,
    banner_image_mobile: MSCBannerMobile,
  },

  "jr-cigars" : {
    name: "JR Cigars",
    tagline: "The world's largest cigar store",
    content: `<p>JR Cigars is the ultimate online cigar retail experience, innovating each step of the consumer experience with its online store jrcigars.com and its digital platforms. JRcigars.com attracts over 100,000 unique users each month and is the premier retailer for the best cigar deals and products.</p><p>Aside from jrcigars.com, JR has various other platforms to enhance the cigar experience for its users. Check out the JR Cigars network:</p>
    <ul>
      <li>
        <h3>JR Auctions</h3>
        <span>The home of cigar auctions at great prices.</span>
        <div class="actions">
          <a href="https://play.google.com/store/apps/details?id=com.jrcigars.auctions" class="themed-btn android"></a>
        </div>
      </li>
      <li>
        <h3>Beat The Dealer</h3>
        <span>Try your luck at our slots game to win daily cigar prizes and coupons.</span>
      </li>
      <li>
        <h3>Steals and Deals</h3>
        <span>The best way to shop cigars on the go - directly from your mobile in just a few taps.</span>
        <div class="actions">
          <a href="https://itunes.apple.com/app/us/steals-deals/id1188954688?mt=8" class="themed-btn iOS"></a>
          <a href="https://play.google.com/store/apps/details?id=com.jrcigars.shopjr" class="themed-btn android"></a>
        </div>
      </li>
    </ul>`,
    links: {
      web: "https://www.jrcigars.com/",
      android: '',
      iOS: '',
    },
    logo_image: JRlogo,
    banner_image: JRcigarsBanner,
    banner_image_mobile: JRcigarsBannerMobile
  },

  "cigars.com": {
    name: "Cigars.com",
    tagline: "Powered By You",
    content: `<p>Cigars.com is a premium cigar shopping experience driven by its adult consumers. The mantra "Powered By You" has crafted the ideals behind the online cigar experience. At Cigars.com, we understand the community of cigar loving fans and experts and believe that the cigar experience from start to finish should be powered by you.</p><p>Explore unique features like Build Your Own Sampler and connect with other adult cigar enthusiasts through the blog-like feed of the latest in the cigar community. Consult the community for video and written reviews of all the top cigar products, from national brands to accessories. Cigars.com's online portfolio includes top cigar brands, accessories and more.</p><p>Check out the community for yourself at <a href="https://www.cigars.com">Cigars.com!</a></p>`,
    links: {
      web: "https://www.cigars.com/",
    },
    logo_image: CigarsLogo,
    banner_image: CigarsComBanner,
    banner_image_mobile: CigarsComBannerMobile
  },

  "serious-cigars": {
    name: "Serious Cigars",
    tagline: "Premium cigars since 1997",
    content: `<p>Serious Cigars, a longstanding online and brick-and-mortar cigar retailer in the Houston area, was acquired in late 2016 by Tabacalera USA. Since the acquisition, Serious Cigars has seen a newly improved website experience at seriouscigars.com.</p><p>The retail network of four Texas locations was taken over by Casa de Montecristo, bringing these stores into the growing network of the Casa family across the United States.</p><p>Explore seriouscigars.com to see the extensive selection of premium cigars, exclusive cigar deals and top-of-the-line cigar accessories to complete the experience.</p>`,
    links: {
      web: "https://www.seriouscigars.com/",
    },
    logo_image: SeriousCigarsLogo,
    banner_image: SeriousCigarsBanner,
    banner_image_mobile: SeriousCigarsBannerMobile,
  },

  "beat-the-dealer": {
    name: "Beat The Dealer",
    tagline: "Test your luck in the all new slots game",
    content: `<p>Beat the Dealer, originally released for iOS in May 2015, is redefining the online cigar community. With the new release of www.beatthedealerapp.com, you can now access the fan-favorite game from any browser or device.</p><p>The Beat the Dealer App has fast become an integral part of the JR Cigar eco-system driving new customer acquisition and incremental sales. The app and web experience allow users to play the new slot machine for a chance to win daily premium cigar prizes.</p>`,
    links: {
      web: "https://www.beatthedealerapp.com/",
      android: 'https://play.google.com/store/apps/details?id=com.jrcigars.beatthedealer',
      iOS: ''
    },
    logo_image: BTDlogo,
    banner_image: BTDbanner,
    banner_image_mobile: BTDBannerMobile
  },

  "santa-clara": {
    name: "Santa Clara",
    tagline: "Cigar wholesalers since 1971",
    content: `<p>Santa Clara Cigars is one of the largest distributors of cigars and tobacco products in the United States. The company sells wholesale tobacco and tobacco products to the trade only.</p><p>Santa Clara's competitive advantage is evident in the quality of their service, the wide selection of cigars and tobacco products, combined with everyday low prices. Santa Clara customers can purchase online, by phone or via fax. Their state-of-the-art ordering systems make buying through Santa Clara an unbeatable experience.</p><p>Shop Santa Clara for exclusive premium handmade cigars in boxes, bundles, 5-packs, samplers, exclusive private label brands, domestic cigars, pipes, pipe tobacco and accessories - the true one-stop wholesale supplier for all your tobacco-related needs.</p>`,
    links: {
      web: "https://www.santaclaracigars.com/",
    },
    logo_image: SantaClaraLogo,
    banner_image: SantaClaraBanner,
    banner_image_mobile: SantaClaraBannerMobile,
  },

  "casa-de-montecristo": {
    name: "Casa de Montecristo",
    tagline: "Reinventing the premium retailing experience",
    content: `<p>Casa de Montecristo stores are expanding across the United States.</p><p>By the end of 2018 Casa de Montecristo will have its name on 28 retail locations across 11 states. Plans for further expansion will continue into 2019 and beyond.</p><p>For the best selection of cigars with a superior lounge and bar experience, look no further than Casa de Montecristo.</p>`,
    links: {
      web: "https://www.casademontecristo.com/",
    },
    logo_image: CDMlogo,
    banner_image: CDMbanner,
    banner_image_mobile: CDMBannerMobile,
  },
};

export default companies;



// WEBPACK FOOTER //
// ./src/containers/OurCompaniesDetail/companyData.ts